"use client"

import type React from "react"
import { useState, useEffect, useCallback } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { Container, Row, Col, Spinner, Alert } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import RoleMenuManagement from "./role-menu-management"
import { RoleService } from "../../../Service/role-management-service"
import type { Role } from "../rolemanagement/types"
import { toast } from "react-toastify"

const RoleMenuManagementContainer: React.FC = () => {
  const { roleId } = useParams<{ roleId: string }>()
  const navigate = useNavigate()

  const [role, setRole] = useState<Role | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchRole = useCallback(async () => {
    if (!roleId) {
      setError("No role specified")
      setLoading(false)
      return
    }

    try {
      setLoading(true)
      setError(null)
      const roleData = await RoleService.getById(Number.parseInt(roleId, 10))
      setRole(roleData)
    } catch (err: any) {
      console.error("Failed to fetch role:", err)
      const errorMessage = err.message || "Failed to load role"
      setError(errorMessage)
      toast.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }, [roleId])

  useEffect(() => {
    fetchRole()
  }, [fetchRole])

  const handleNavigateBack = useCallback(() => {
    navigate("/role-management")
  }, [navigate])

  return (
    <>
      <Breadcrumbs
        mainTitle="Role Menu Management"
        parent="Role Management"
       
      />
      <Container fluid>
        <Row>
          <Col md="12">
            {loading ? (
              <div className="text-center py-5">
                <Spinner color="primary" size="lg" />
                <div className="mt-3">Loading role information...</div>
              </div>
            ) : error ? (
              <Alert color="danger" className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>Error:</strong> {error}
                </div>
                <button className="btn btn-outline-danger btn-sm" onClick={handleNavigateBack}>
                  Back to Roles
                </button>
              </Alert>
            ) : (
              <RoleMenuManagement role={role} />
            )}
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default RoleMenuManagementContainer
